export const LATEST_DOCS_TYPE = {
  STAR: 'Star14',
  PENCLE: 'Edit14',
  PET: 'Pet14',
  RIGHTARROW: 'RightArrowO',
  RIGHTARROW2: 'RightArrow12',
  PLUS: 'Plus12',
  QUEST: 'QuestItem20',
} as const;

export type LATEST_DOCS_TYPE_KEY = keyof typeof LATEST_DOCS_TYPE;

export type LATEST_DOCS_TYPE_VALUE =
  typeof LATEST_DOCS_TYPE[LATEST_DOCS_TYPE_KEY];
